import { render, staticRenderFns } from "./NewVersionIntegration.vue?vue&type=template&id=986c2f0c&scoped=true"
import script from "./NewVersionIntegration.vue?vue&type=script&lang=js"
export * from "./NewVersionIntegration.vue?vue&type=script&lang=js"
import style0 from "./NewVersionIntegration.vue?vue&type=style&index=0&id=986c2f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986c2f0c",
  null
  
)

export default component.exports